import React from 'react';
import {useDispatch} from 'react-redux';

import {completePasswordReset} from 'modules/authentication/actions';

import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import AuthenticationContainer from './AuthenticationContainer';

export default function ResetResult(props) {

    const {children} = props;

    const dispatch = useDispatch();

    const continueAction = () => {
        dispatch(completePasswordReset());
    }

    return <AuthenticationContainer title="Reset Password">
        {children}
        <CancelAndContinueButtons continueAction={continueAction}/>
    </AuthenticationContainer>;

}